// eslint-disable-next-line
export default () => ({
    root: {
      position:"absolute",
      top:"50%",
      left:"50%",
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: '100%',
      transform: `translate(-50%, -50%)`,
      zIndex:999
    },
    progress: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50%'
    }
  })
  